import { AvatarWithLabel, AvatarLetter } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function UserAvatar(props) {
    const { title, subTitle } = props;
    return (<AvatarWithLabel size="md" title={title || ''} subtitle={subTitle || ''} appearance="cyan">
      {title ? (<AvatarLetter>{title.charAt(0).toUpperCase()}</AvatarLetter>) : (<Falcon icon="user"/>)}
    </AvatarWithLabel>);
}
